<template>
  <div class="contents">
      <div class="content-wrapper">
        <div class="container">
          <div class="box">
            <contentBox c_id=0 link="/company" />
          </div>

          <div class="box">
            <contentBox c_id=1 link="/team" />
          </div>

          <div class="box">
            <contentBox c_id=2 link="/gallery" />
          </div>

          <div class="box">
            <contentBox c_id=3 link="/recruit" />
          </div>

        </div>
      </div>
  </div>
</template>

<script>

import contentBox from '@/components/home/contentBox.vue'

export default {
  name: 'contents',
  props: {
    msg: String
  },
  components: {
    contentBox
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .contents{
    background-color: #fff;
    padding-top: 8.3vw;
    padding-left: 20px;
    padding-right: 0px;
    position: relative;
    z-index: 1;
  }
  .content-wrapper{
  }
  .container{
    width: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content:center;

    .box{
      width:  46vw;
      height: 68.3vw;
      margin-bottom: 8.3vw;
      max-width: 909px;
      max-height: 1350px;
      margin-right: 20px;

      @media (max-width: 1000px) {
        width: 94vw;
        height: 114.7vw;
      }
      @media (max-width: 550px) {
        width: 94vw;
        height: 114.7vw;
        min-width: 90vw;
        min-height: 114.7vw;
        margin-bottom: 25vw;
      }
    }
  }

</style>
